<template>
  <div>
    <span
      id="copy-performance-url"
      class="block text-fg-link-primary cursor-pointer"
      @click="copyPerformanceUrl"
    >
      {{ copyPerformanceUrlLabel }}
    </span>
    <router-link
      v-if="selectedPerformance"
      id="go-to-show-details"
      :to="{ name: 'showDetail', params: { id: selectedPerformance.show.id } }"
      class="text-fg-link-primary cursor-pointer"
    >
      Go to Show Details
    </router-link>
    <span
      id="delete-performance"
      class="text-fg-link-primary"
      :class="!canDeletePerformance ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'"
      :aria-disabled="!canDeletePerformance"
      @click="displayDeleteModal = true"
    >
      Delete Performance
    </span>
    <teleport to="body">
      <PerformanceDeleteModal
        v-if="selectedPerformance"
        v-model="displayDeleteModal"
        :performance="selectedPerformance"
        :canBeDeleted="canDeletePerformance"
      />
    </teleport>
  </div>
</template>

<script lang="ts" setup>
import * as _ from 'lodash-es'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import PerformanceDeleteModal from '@/modules/performance/components/organisms/PerformanceDeleteModal.vue'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import { useSettingStore } from '@/stores/setting'

import { ReservationStatus } from '@generated/types'

const settingStore = useSettingStore()
const performanceReservationStore = usePerformanceReservationStore()
const { selectedPerformance } = storeToRefs(performanceReservationStore)
const copyPerformanceUrlLabel = ref<string>('Copy URL')
function copyPerformanceUrl() {
  if (!selectedPerformance.value) return
  const showDate = settingStore.dateIsoStr(selectedPerformance.value.datetime)
  const url = `${window.location.origin}/shows/${selectedPerformance.value.show_id}/?date=${showDate}`
  navigator.clipboard.writeText(url)
  copyPerformanceUrlLabel.value = 'Copied!'
  setTimeout(() => {
    copyPerformanceUrlLabel.value = 'Copy URL'
  }, 5000)
}

const displayDeleteModal = ref<boolean>(false)
const canDeletePerformance = computed<boolean>(() => {
  if (!selectedPerformance.value) return false
  return (
    _.reject(selectedPerformance.value?.reservations, { status: ReservationStatus.CANCELED })
      .length === 0
  )
})
</script>
